import { TransportCustomModalCell } from './components/transport-custom-modal-cell';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const AUTOPARK_TRANSPORT_FORM_NAME = 'autopark-transport-form';

export const REQUIRED_FIELDS = ['name', 'type_id', 'weight', 'volume', 'count'];

export const FIELDS_FOR_VALIDATE = [
	'name',
	'is_allow',
	'type_id',
	'weight',
	'volume',
	'count',
	'address_id',
	'is_deny_refund',
	'tariffs.*.transport_cost_per_shift',
	'tariffs.*.performer_cost_per_shift',
	'tariffs.*.performer_cost_per_unit',
	'tariffs.*.performer_stage_length',
	'tariffs.*.performer_cost_per_unit_sub',
	'tariffs.*.transport_cost_per_unit',
	'tariffs.*.transport_stage_length',
	'tariffs.*.transport_cost_per_unit_sub',
];

export const TRANSPORT_TABLE_COLUMNS_NAMES = [
	{ id: 'title' },
	{ id: 'value', customComponent: TransportCustomModalCell },
];

export const TRANSPORT_TABLE_ROWS_NAMES = {
	is_allow: 'Доступен',
	type: 'Тип транспорта',
	weight: 'Грузоподъемность',
	volume: 'Вместимость',
	count: 'Кол-во доступного авто',
	address: 'Стартовая локация',
	is_deny_refund: 'Запретить учет возврата на склад',
	author: 'Автор',
	tariffs: '',
};

export const TRANSPORT_TARIFF_TYPES_TABLE_ROWS_NAMES = {
	transport_cost_per_shift: 'Стоимость выхода транспорта на рейс',
	performer_cost_per_shift: 'Стоимость выхода водителя на рейс',
	performer_cost_per_unit: 'Цена за час пути',
	performer_stage_length: 'Кол-во первых часов',
	performer_cost_per_unit_sub: 'Стоимость сверх базового часа',
	transport_cost_per_unit: 'Цена за км пути',
	transport_stage_length: 'Кол-во первых км',
	transport_cost_per_unit_sub: 'Стоимость 1 км пробега свыше базового',
};
